// extracted by css-extract-rspack-plugin
export default {"inlineAnnotation":"InlineAnnotation-module__inlineAnnotation__DWZ_k"};